import AddWidget from './AddWidget';
export default AddWidget;

//# sourceMappingURL=index.js.map